// extracted by mini-css-extract-plugin
export default {"activityLog":"ActivityLog_activityLog__oRtGR","title":"ActivityLog_title__JqxGK","item":"ActivityLog_item__PSSgY","text":"ActivityLog_text__6onIr","date":"ActivityLog_date__NZuB6"};